import React from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getVehicle } from '../ducks/vehicles.js'

import VehiclesForm from './vehicles_form.jsx'

const VehiclesEdit = () => {
  const { id } = useParams()
  return (
    <ConnectedForm vehicleId={id} />
  )
}

const ConnectedForm = connect(
  (state, props) => ({
    vehicle: getVehicle(state.vehicles, props.vehicleId)
  })
)(({ vehicle }) => (
  <VehiclesForm vehicle={ vehicle } />
))

export default VehiclesEdit
